<template>
<div class="container">
        <div class="row justify-content-center mt-20">
          <div class="col-lg-6">
            <div class="section-title-wrapper mb-20">
              <h2 class="section-title font-weight--light">Feedback on Apif</h2>
            </div>
            <b-form v-if="!success">
              <h6>Why did you stop using Apif?</h6>
              <p class="optional">You can select multiple options</p>
              <b-form-checkbox
                id="checkbox-complicated"
                v-model="form.complicated"
                name="checkbox-complicated"
              >
                It felt too complicated
              </b-form-checkbox>

              <b-form-checkbox
                id="checkbox-features"
                v-model="form.features"
                name="checkbox-features"
              >
                Lacks the features I'm looking for
              </b-form-checkbox>

              <b-form-checkbox
                id="checkbox-price"
                v-model="form.price"
                name="checkbox-price"
              >
                Too expensive
              </b-form-checkbox>
              <b-form-checkbox
                id="checkbox-anotherService"
                v-model="form.anotherService"
                name="checkbox-anotherService"
              >
                I found another similiar service
              </b-form-checkbox>
              <b-form-checkbox
                id="checkbox-issues"
                v-model="form.issues"
                name="checkbox-issues"
              >
                I had issues with the service and it did not functioned properly
              </b-form-checkbox>
              <b-form-checkbox
                id="checkbox-information"
                v-model="form.information"
                name="checkbox-information"
              >
                  Lacked information and support on how to use the service
              </b-form-checkbox>
              <b-form-checkbox
                id="checkbox-other"
                v-model="form.other"
                name="checkbox-other"
              >
                  Other reasons
              </b-form-checkbox>

              <hr />


              <div v-show="form.complicated">
                <label for="complicatedText"><span>What aspects of the service felt complicated? <span class="optional">(optional)</span></span></label>
                <b-form-textarea
                  class="mb-4"
                  id="complicatedText"
                  v-model="form.complicatedText"
                  placeholder=""
                  rows="3"
                  max-rows="6"
                />
              </div>
              <div v-show="form.features">
                <label for="featuresText"><span>What features do you think is missing? <span class="optional">(optional)</span></span></label>
                <b-form-textarea
                  class="mb-4"
                  id="featuresText"
                  v-model="form.featuresText"
                  placeholder=""
                  rows="3"
                  max-rows="6"
                />
              </div>
              <div v-show="form.anotherService">
                <label for="anotherServiceText"><span>What other service did you found? <span class="optional">(optional)</span></span></label>
                <b-form-input
                  class="mb-4"
                  id="anotherServiceText"
                  v-model="form.anotherServiceText"
                />
              </div>
              <div v-show="form.issues">
                <label for="issuesText"><span>What issues did you experience? <span class="optional">(optional)</span></span></label>
                <b-form-textarea
                  class="mb-4"
                  id="issuesText"
                  v-model="form.issuesText"
                  placeholder=""
                  rows="3"
                  max-rows="6"
                />
              </div>
              <div v-show="form.information">
                <label for="informationText"><span>What type of information was missing? <span class="optional">(optional)</span></span></label>
                <b-form-textarea
                  class="mb-4"
                  id="informationText"
                  v-model="form.informationText"
                  placeholder=""
                  rows="3"
                  max-rows="6"
                />
              </div>

              <div v-show="form.other">
                <label for="otherText"><span>Would you mind elaborating your other reasons? <span class="optional">(optional)</span></span></label>
                <b-form-textarea
                  class="mb-4"
                  id="otherText"
                  v-model="form.otherText"
                  placeholder=""
                  rows="3"
                  max-rows="6"
                />
              </div>

              <p style="color: #c26bbb;" v-show="error">{{ msg }}</p>
              <b-button class="btn btn--green signup" @click="onSubmit" :disabled="!isEnabled">Send</b-button>
            </b-form>
            <div v-if="success">
            <h5 style="color: #c26bbb;" class="font-weight--light">{{ msg }}</h5>
            <br/>
            <h5  style="color: #c26bbb;">{{ discount }}</h5>
            <br/>
            <p class="font-weight--light">
              Thanks!<br/>
              - The Apif Team
            </p>
            </div>
          </div>
        </div>
      </div>
</template>

<script>
import firebase from "firebase";

export default {
  name: "Survey",
  components: {

  },
  data() {
    return {
      form: {
        complicated: false,
        price: false,
        features: false,
        anotherService: false,
        issues: false,
        information: false,
        other: false,

        featuresText: '',
        issuesText: '',
        complicatedText: '',
        anotherServiceText: '',
        otherText: '',

        surveyType: "feedback",
        surveyId: 'surveyChurn',
        added: new Date()
      },
      success: false,
      error: false,
      msg: "",
      discount: "",
    };
  },
  computed: {
    isEnabled() {
      if (this.form.complicated || 
        this.form.price ||
        this.form.features ||
        this.form.anotherService ||
        this.form.issues ||
        this.form.information ||
        this.form.other)
        return true;
      else return false;
    }
  },
  methods: {
    onSubmit() {
      this.success = false;
      this.error = false;

      this.save();
    },
    save() {
      return firebase
        .firestore()
        .collection("surveys")
        .doc("surveyChurn")
        .collection("posts")
        .add(this.form)
        .then(() => {
          this.success = true;
          this.msg = "Thank you for providing your thoughts and feedback, it's truly appreciated!";
          this.discount = "Your 50% discount code is: NWZW9VBQ";
        })
        .catch((err) => {
          console.log(err);
          this.error = true;
          this.msg = "Oops, something went wrong, please try again";
        });
    },
  },
};
</script>

<style scoped>
  .optional {
    display: inline-block;
    color: lightgrey;
  }
</style>